import { Passenger } from '@app/models/micro/passenger.model';

export function getSeatRouteByPassengerCount(): string {
  return '/seat/selectSeat';
}

/**
 * Determina qué pasajeros realmente cambiaron de asiento comparando
 * el asiento original (seats) con el nuevo seleccionado (seatsNew).
 */
export function getPassengersWithSeatChange(
  passengers: Passenger[]
): Passenger[] {
  return passengers.filter((passenger) => {
    if (!passenger.seatsNew?.length) {
      return false;
    }

    return passenger.seatsNew.some((seat) => {
      const currentCode = seat.code || seat.seatCode || '';
      const oldCode = seat.seatCodeOld || '';

      return seat.isChangeSeat && currentCode !== oldCode;
    });
  });
}